



import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
				Ĉu vere, ke neniam mi ekvidos <br/>
				La finan kvinan akton de “Karmen’”? <br/>
				Malica fort’ nin ĉiujn vipe gvidas <br/>
				Al memestingo kaj al malEden’.
      </p>
			
      <p class="poem-block mb-3">
				Sirenoj muĝas pro aerdanĝero, <br/>
				Al rifuĝej’ sin ĵetas la publik’, <br/>
				Kurteno falas… Premas atmosfero <br/>
				Kaj jam neniu zorgas pri l’ klasik,
      </p>
			
      <p class="poem-block mb-3">
				Spektakl’ rompiĝis. Ĉu aperos ree <br/>
				Sur la scenej’ kantanta aktorar’? <br/>
				Aŭ baldaŭ ĝi eksonos jam armee? <br/>
				De stulta disvolvanta sin koŝmar’
      </p>
			
      <p class="poem-block">
				Aper’ senfina. Oper’ sen fino… <br/>
				Sirene sonas voĉo de l’ destino.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Pri iu evento okazinta dum prezentado de opero “Karmen’”',
  forLink: 'Pri iu evento okazinta dum prezentado de opero Karmen'
}
const itemDate = {
  esp: '15 majo 2024'
}

const item = {
  itemlink: getLink(itemName.forLink),
  esp: {
    itemName: itemName.esp,
    itemDate: itemDate.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}
export default item;






